import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NetworkV2 } from '@netfoundry-ui/shared/model';
import { NETWORK_SERVICE, NetworkServiceV2 } from '@netfoundry-ui/shared/apiv2';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { FromDatePipe } from '@netfoundry-ui/ui/pipes';
import moment from 'moment';
import { ApiService } from '@netfoundry-ui/shared/services';

@Component({
    selector: 'app-events-tab',
    templateUrl: './events-tab.component.html',
    styleUrls: ['./events-tab.component.scss'],
    providers: [FromDatePipe],
    standalone: false
})
export class EventsTabComponent implements OnInit, OnDestroy {
    @Input() data: any;

    currentNetwork = new NetworkV2();
    dateFilter = '24h';
    endTime: number = Date.now();
    startTime: number = this.endTime - 24 * 60 * 60 * 1000;
    endpoint: any;
    edgeRouter: any;
    networkGroupId: any;

    private subscription = new Subscription();

    constructor(
        @Inject(NETWORK_SERVICE) private networkServiceV2: NetworkServiceV2,
        public apiService: ApiService,
        private fromDate: FromDatePipe,
    ) {}

    ngOnInit() {
        this.data = this.data || {};
        if (this.data.model?.hostId || this.data.resourceType !== 'endpoint') {
            this.edgeRouter = this.data.model;
        } else {
            this.endpoint = this.data.model;
        }
        this.networkGroupId = this.data.networkGroupId;

        this.subscription.add(
            this.apiService.currentNetwork.pipe(debounceTime(1000)).subscribe((network) => {
                this.initData(network.id);
            })
        );
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    setStartTime(value: string) {
        this.startTime = this.fromDate.transform(value);
        this.endTime = Date.now();

        if (value === '1m' || value === '6m' || value === '12m') {
            this.endTime = moment(this.endTime).endOf('month').valueOf();
        }
        this.dateFilter = value;
    }

    private initData(networkId: any) {
        this.networkServiceV2.getNetwork(networkId).then((nw: NetworkV2) => {
            this.currentNetwork = nw;
        });
    }
}
